/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import DynamicElement from 'fierry/rpc.old/dynamic-element';
import NativeConstants from 'astro/server/constants';

import * as Key from 'astro/rpc/key';
import * as Translator from 'astro/rpc/translator';


export default class extends DynamicElement
{
  constructor ()
  {
    super(NativeConstants);

    this.createTable('projectiles', Key.Type, [ Translator.ProjectileConstants ]);
    this.createTable('buildings', Key.Type);
    this.createTable('entities', Key.Variant);
    this.createTable('units', Key.Type, [ Translator.UnitConstants ]);

    this.createTable('themes', Key.Type);
  }
}
